import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

import { textPrimary } from 'app/components/ThemeProvider/colors';

const BellIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox='0 0 19 22'
      fill='none'
      sx={{ width: '19px', height: '22px', fill: 'none', ...sx }}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.25 16.5976C14.8892 16.5976 17.4981 15.8742 17.75 12.9705C17.75 10.0688 15.9312 10.2554 15.9312 6.69511C15.9312 3.91414 13.2952 0.75 9.25 0.75C5.20477 0.75 2.56885 3.91414 2.56885 6.69511C2.56885 10.2554 0.75 10.0688 0.75 12.9705C1.00295 15.8852 3.61177 16.5976 9.25 16.5976Z'
        fill='none'
        stroke={textPrimary}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.6389 19.6072C10.2747 21.1219 8.14672 21.1399 6.76953 19.6072'
        fill='none'
        stroke={textPrimary}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </SvgIcon>
  );
};

export default BellIcon;
